import './loading-spinner.css';
import { h } from 'preact';

const { __ } = wp.i18n;

export default function LoadingSpinner() {
	return (
		<div class="loading-spinner">{__('Loading..', 'real-estate-project')}</div>
	);
}
